import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store/store";
import SecurityRouter from "./common/security-router";
import { TranslationProvider } from "./common/translation-context";
import { ErrorContextProvider } from "./common/error-context";
import { ModalContextProvider } from "./common/modal-context";
import { LicenseInfo } from "@mui/x-data-grid-pro";

LicenseInfo.setLicenseKey(
    "be22e51dd92b80cb793bf4d3973fbb67Tz0xMjQ2NDUsRT0xODAxNTI2NDAwMDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI="
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <TranslationProvider translationFile="global">
        <ErrorContextProvider>
          <ModalContextProvider>
            <Router>
              <SecurityRouter />
            </Router>
          </ModalContextProvider>
        </ErrorContextProvider>
      </TranslationProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
